var _circle, _path, _path2, _rect, _path3, _ellipse, _rect2, _path4, _rect3, _rect4, _rect5, _rect6, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmusementParkTrainContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.993 21.5719L48.1544 21.073L47.6483 20.9355C45.1603 20.2598 43.3359 17.9995 43.3359 15.3207C43.3359 12.1092 45.9581 9.5 49.1998 9.5C52.007 9.5 54.3511 11.4575 54.9277 14.068L55.019 14.4815L55.442 14.4594C55.5107 14.4559 55.58 14.454 55.6497 14.454C57.7991 14.454 59.5357 16.1837 59.5357 18.3102C59.5357 20.3095 58.0005 21.9582 56.0305 22.1481L55.5675 22.1927L55.5786 22.6577C55.5794 22.6889 55.5797 22.7203 55.5797 22.7517C55.5797 24.8782 53.8432 26.6078 51.6938 26.6078C49.5444 26.6078 47.8079 24.8782 47.8079 22.7517C47.8079 22.3394 47.8729 21.9432 47.993 21.5719Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3076 28.3036H56.5955L56.0795 36.1617H47.9956L47.3076 28.3036Z",
    fill: "#18252C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.39453,
    y: 54.9625,
    width: 56.2871,
    height: 6.3891,
    fill: "#18252C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1799 64.7937L65.3551 55.6225C65.2253 55.4876 65.0462 55.4114 64.8591 55.4114H60.0598C59.6796 55.4114 59.3713 55.7196 59.3713 56.0998V65.271C59.3713 65.6512 59.6796 65.9594 60.0598 65.9594H73.6839C74.2908 65.9594 74.6008 65.231 74.1799 64.7937Z",
    fill: "#18252C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.5575,
    cy: 46.4456,
    rx: 10.0206,
    ry: 9.55818,
    transform: "rotate(90 62.5575 46.4456)",
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.9451,
    y: 36.4249,
    width: 28.6745,
    height: 20.0413,
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 24.822H36.007V56.4662H8.39453L8.39453 52.7836C8.39453 50.7409 10.0505 49.0849 12.0932 49.0849H12.9167V40.6441V24.822Z",
    fill: "#1E1E1E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1885,
    y: 23.0079,
    width: 26.4876,
    height: 2.73326,
    rx: 0.809765,
    fill: "#18252C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8289,
    y: 27.9865,
    width: 16.9923,
    height: 14.7673,
    rx: 0.809765,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8005,
    y: 44.7032,
    width: 5.50391,
    height: 1.70829,
    rx: 0.809765,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.9561,
    y: 38.0409,
    width: 27.6916,
    height: 5.46652,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4081 56.9175C33.4081 61.7837 29.4344 65.7402 24.5183 65.7402C19.6021 65.7402 15.6284 61.7837 15.6284 56.9175C15.6284 52.0513 19.6021 48.0948 24.5183 48.0948C29.4344 48.0948 33.4081 52.0513 33.4081 56.9175Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.681 60.3326C47.681 63.3111 45.2481 65.7372 42.2326 65.7372C39.2171 65.7372 36.7842 63.3111 36.7842 60.3326C36.7842 57.3541 39.2171 54.928 42.2326 54.928C45.2481 54.928 47.681 57.3541 47.681 60.3326Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3034 60.3326C62.3034 63.3111 59.8705 65.7372 56.8549 65.7372C53.8394 65.7372 51.4065 63.3111 51.4065 60.3326C51.4065 57.3541 53.8394 54.928 56.8549 54.928C59.8705 54.928 62.3034 57.3541 62.3034 60.3326Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7431 26.6901C46.7713 26.5363 46.9054 26.4246 47.0617 26.4246H56.8416C56.998 26.4246 57.132 26.5363 57.1602 26.6901L57.3856 27.9214C57.422 28.1204 57.2692 28.3037 57.067 28.3037H46.8363C46.6341 28.3037 46.4813 28.1204 46.5177 27.9214L46.7431 26.6901Z",
    fill: "#18252C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmusementParkTrainContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AmusementParkTrainContrast.3cd62b0e8e0007415bf667f79ceb37a8.svg";